module.exports = __webpack_public_path__ + "static/media/bt.508393de.svg";